import React = require('react')
import { Action, async, AsyncState, IOWidget, mkWidget, mk_pair } from 'widgets-for-react'
import { Page } from '../../../../cms/page/types.gen'
import { CustomRouteParams } from '../../../../cms/router/type.gen'
import { getDrupalLanguage, PublicSite_CustomPageData } from '../../../application.mod'
import { CustomPagesState, PublicSiteCustomRoutes, TagTitle, TagValues } from '../../types.mod'
import { ParsedOverviewDetailItem } from './components/overviewItemsBlock/overview_items_block'
import { PageKind, renderOverviewPage } from './overview_page'
import { getStyle } from './overview_page_layout'
import { datalayerHandler } from '../../../../cms/blocks/utils/gtm.mod'
import { PaginatedItemStone } from '../../../../drupal/api/api.mod'
import { Block } from 'typescript'
import { getTranslatedCareersSlugTitle, PublicSiteState } from '../../../../../public_site.main.mod'
import { CustomBlock } from '../../../../drupal/types_and_parser/custom_blocks.mod'
import { Map, List } from 'immutable'
import { vacancyOverviewPageHeader } from '../../../templates/custom_page_header'
import { Breadcrumbs } from '../../../templates/breadcrumbs.mod'
import { t } from 'i18next'
import { getLangFromUrl } from '../../../utils/history.mod'

type overviewWidgetInputType = {
  routes: CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>
  state: CustomPagesState['overview']
}

export const overviewWidget: (loadOverviewItems: (page_kind: PageKind, tags: Map<TagTitle, TagValues>, searchQuery: string, page_index: number, page_size?: number, lang?: string) => AsyncState<PaginatedItemStone<ParsedOverviewDetailItem>>) => IOWidget<overviewWidgetInputType, Action<CustomPagesState['overview']>> = (loadOverviewItems) => (appState) => {

  let project = "wordpress"
  return mkWidget({
    run: (setState: (_: Action<CustomPagesState['overview']>) => void) => {
      let overviewState = appState.state

      const layout = getStyle(overviewState.pageKind)

      const customJsx = renderOverviewPage(loadOverviewItems)(overviewState, mk_pair(appState.routes, appState.state), setState, layout, appState.state.pageKind)


      const setOverviewItems = (
        state: CustomPagesState['overview'],
        updatedState: AsyncState<PaginatedItemStone<ParsedOverviewDetailItem>>
      ): CustomPagesState['overview'] => {
        return { ...state, overview_items: updatedState }
      }

      const setOverviewTags = (
        state: CustomPagesState['overview'],
        updatedState: AsyncState<string[]>,
        tagName?: string
      ): CustomPagesState['overview'] => {
        return {
          ...state,
          tags: tagName ? state.tags.set(tagName, updatedState) : state.tags,
          // industryTags: (!tagName || tagName == "industry") ? updatedState : state.industryTags, 
          // typeTags: (!tagName || tagName == "type") ? updatedState : state.typeTags, 
          selected_options: { ...state.selected_options, currentPage: 0 }
        }
      }

      const setOverviewPage = (
        state: CustomPagesState['overview'],
        updatedState: AsyncState<Page<CustomBlock, Block, PublicSite_CustomPageData>>
      ): CustomPagesState['overview'] => {
        return { ...state, overview_page: updatedState as any }
      }

      const currentLang = getLangFromUrl()
      let careersSlugTranslationData = getTranslatedCareersSlugTitle()
      let careersSlug = careersSlugTranslationData.slug[currentLang]
      let careersTitle = careersSlugTranslationData.title[currentLang]

      return (
        <>
          {async<PaginatedItemStone<ParsedOverviewDetailItem>>()(overviewState.overview_items).run((res) =>
            setState((previousState) => {
              const newState = res(overviewState.overview_items)
              if (newState.kind == "loaded") {
                // if (overviewState.selected_options.searchQuery == "" || overviewState.selected_options.searchQuery == undefined) {

                //   if (document.querySelector(".block__filters")?.classList?.contains("hidden")) {
                //     document.querySelector(".block__filters")?.classList?.toggle("hidden")
                //   }
                // }

                if (overviewState.selected_options.searchQuery != undefined && overviewState.selected_options.searchQuery != "") {
                  datalayerHandler("search", newState.value.pager.totalItems > 0 ? "result" : "no_result", 'search_' + overviewState.pageKind, { label: overviewState.selected_options.searchQuery })
                }


                // window.dataLayer = window.dataLayer || [];
                // window.dataLayer.push({
                //   event: `event.${sitename}`,
                //   category: appState.state.pageKind,
                //   action: "search-result",
                //   label: newState.value.pager.totalItems > 0 ? "Resultaat" : "Geen resultaat"
                // })
              }
              return setOverviewItems(previousState, newState)
            })
          )}
          {
            appState.state.tags.map((v, k) => {
              return async<string[]>(undefined, { key: `${k}-${v.kind}` })(v).run((res) =>
                setState((previousState) => {
                  const newState = res(overviewState.tags.get(k))
                  return setOverviewTags(previousState, newState, k)
                })
              )
            }).valueSeq().toArray()
          }
          {/* {async<string[]>()(overviewState.industryTags).run((res) =>
            setState((previousState) => {
              const newState = res(overviewState.industryTags)
              return setOverviewTags(previousState, newState, "industry")
            })
          )}
          {async<string[]>()(overviewState.typeTags).run((res) =>
            setState((previousState) => {
              const newState = res(overviewState.typeTags)
              return setOverviewTags(previousState, newState, "type")
            })
          )} */}
          {/* {async<Page<CustomBlock, Block, PublicSite_CustomPageData>>()(overviewState.overview_page as any).run((res) =>
            setState((previousState) => {
              const newState = res(overviewState.overview_page  as any)
              return setOverviewPage(previousState, newState)
            })
          )} */}



          <main className="main main--vacancies">
            {vacancyOverviewPageHeader(currentLang, careersSlug, careersTitle).run(_ => ({ _ }))}

            <div className="main__inner">
              <article className="page">
                <div className="page__inner">
                  {customJsx}
                </div>
              </article>
            </div>
          </main>
        </>
      )
    }
  })
}
